<template>
    <div>
        <v-card>
            <v-card-text>
                <v-card-title class="titulopagina">PLANILLA PCC4</v-card-title>
            </v-card-text>
            <v-card-text>
                <v-row>
                    <v-col cols="2" class="text-right"><h4>Fecha Despacho: </h4></v-col>
                    <v-col cols="2">
                        <date-picker class="float-right" v-model="fecha" placeholder="Fecha Despacho" label="Fecha Despacho" format="DD-MM-YYYY" :default-value="fecha" valueType="YYYY-MM-DD"></date-picker>
                    </v-col>
                    <v-col cols="2">
                        <v-btn dark small color="green darken-1" class="float-right" @click="cargar_despachos"><v-icon>search</v-icon> Buscar</v-btn>
                    </v-col>
                    <v-col cols="2">
                        <v-btn dark small color="green darken-1" class="float-right" @click="exportarExcel"><v-icon>file_download</v-icon> Excel</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <table style="width:100%;">
                <thead>
                    <tr>
                        <th class="text-center cabecera">
                            Fecha
                        </th>
                        <th class="text-center cabecera">
                            Patente
                        </th>
                        <th class="text-center cabecera">
                            Guía/ PCC4
                        </th>
                        <th class="text-center cabecera">
                            N° de Lote
                        </th>
                        <th class="text-center cabecera">
                            Fecha Elaboración
                        </th>
                        <th class="text-center cabecera">
                            Envase / Cantidad
                        </th>
                        <th class="text-center cabecera">
                            C/NC Hora
                        </th>
                        <th class="text-center cabecera">
                            Acción Correctiva
                        </th>
                        <th class="text-center cabecera">
                            Verificacion (Hora C/NC)
                        </th>
                        <th class="text-center cabecera">
                            Observaciones
                        </th>
                        <th class="text-center cabecera">
                            Responsable
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="d in despachos" :key="d.id">
                        <td class="text-center">
                            {{ d.fecha }}
                        </td>
                        <td class="text-center">
                            {{ d.patente }}
                        </td>
                        <td class="text-center">
                            {{ d.guia }} <br>
                            <v-badge color="green" style="margin-top:-20px;" left :content="d.folio_pcc4" ></v-badge>
                        </td>
                        <td class="text-center">
                            {{ d.lote }}
                        </td>
                        <td class="text-center">
                            {{ d.fecha_produccion }}
                        </td>
                        <td class="text-center">
                            {{ d.tipo_envase }} <br>
                            {{ d.cantidad_envase }}
                        </td>
                        <td class="text-center">
                            <input type="checkbox" v-model="d.c_nc" v-if="es_calidad"  @change="grabar_incremento(d, 'c_nc')" />&nbsp;
                            <label>{{ d.c_nc == 1 ? 'Si': 'NO'}}</label>
                            <v-text-field label="C/NC Hora" v-mask="'##:##'" v-model="d.c_nc_hora" @change="grabar_incremento(d, 'c_nc_hora')"></v-text-field>
                        </td>
                        <td class="text-center">
                            <div v-if="d.c_nc != 1">
                                <v-text-field label="Acción Correctiva" v-model="d.accion_correctiva" @change="grabar_incremento(d, 'accion_correctiva')"></v-text-field>
                            </div>
                        </td>
                        <td class="text-center">
                            <div v-if="d.c_nc != 1">
                                <input type="checkbox" v-model="d.verificacion" v-if="es_calidad"  @change="grabar_incremento(d, 'verificacion')" />&nbsp;
                                <label>{{ d.verificacion == 1 ? 'Si': 'NO'}}</label>
                                <v-text-field label="Verif. Hora" v-mask="'##:##'" v-model="d.verif_hora" @change="grabar_incremento(d, 'verif_hora')"></v-text-field>
                            </div>
                        </td>
                        <td class="text-center">
                            <div v-if="d.c_nc != 1">
                                <v-text-field label="Observaciones" v-model="d.observaciones" @change="grabar_incremento(d, 'observaciones')"></v-text-field>
                            </div>
                        </td>
                        <td class="text-center">
                            <div v-if="d.c_nc != 1">
                                <v-text-field label="Responsable" v-model="d.responsable_verif"></v-text-field>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </v-card>
    </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
export default {
    data:() => ({
        despachos: [],
        fecha: '',
        lote: 0,
        guia:0,
        url:'',
        es_calidad: false
    }),
    mounted(){
        let rol_calidad = this.permisos_prod.find(r =>{
            return r.name == "Calidad" || r.name == "Admin";
        })
        if(rol_calidad != undefined) this.es_calidad = true;
        this.fecha = this.moment().format('YYYY-MM-DD HH:mm');
    },
    methods:{
        async cargar_despachos(){
            let url = `${this.base_url}despachos_harina/generar/planilla/${this.guia}/${this.lote}/${this.fecha}`;
            await this.axios.get(url, this.headers).then((res)=>{
                this.despachos = res.data.data;
            }).catch((e)=>{
                console.log(e);
            });
        },
        async exportarExcel(){
            let url = `${this.base_url}despachos_harina/generar/excel`;
            let body = {
                despachos: this.despachos
            }
            await this.axios.post(url, body, this.headers).then((res)=>{
                window.location.href = this.download_url.replace('bitacoras', 'movimientos') + res.data.data;
            }).catch((e)=>{
                console.log(e);
            });

        },
        async grabar_incremento(d, f){
            let url = `${this.base_url}despachos_harina/grabar/incremento`;
            if(typeof d[f] == "boolean") d[f] = d[f] == true ? 1:0;
            let body = {
                despacho_pts_id: d.id,
                incremento: d.incremento,
                campo: f,
                valor: d[f]
            }
            await this.axios.post(url, body, this.headers).then((res)=>{
                console.log(res.data.data);
            }).catch((e)=>{
                console.log(e);
            });
        },
        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },
    computed:{
        ...mapState(['base_url', 'user', 'permisos_prod', 'headers', 'download_url']),
    },
    components:{
        DatePicker
    }
}
</script>
<style scoped>
    td{
        padding: 0em 1em;
        border-bottom:1px solid #01579B !important;
    }

</style>
